import { z } from 'zod';

export const CARE_CHAT_ENTRY_ID_HEADER = 'x-care-chat-entry-id';
export const CARE_CHAT_REQUEST_ID_HEADER = 'x-care-chat-request-id';

export const careChatDiagnosticContextSchema = z.object({
  entry_id: z.uuid(),
  request_attempt_id: z.uuid(),
});
export type CareChatDiagnosticContext = z.infer<typeof careChatDiagnosticContextSchema>;

/** Optional operational context is never an input to authentication or authorization. */
export function parseCareChatDiagnosticContext(
  read: (name: string) => string | undefined,
): CareChatDiagnosticContext | undefined {
  try {
    const entry = read(CARE_CHAT_ENTRY_ID_HEADER);
    const request = read(CARE_CHAT_REQUEST_ID_HEADER);
    if (entry?.length !== 36 || request?.length !== 36) return undefined;
    const parsed = careChatDiagnosticContextSchema.safeParse({
      entry_id: entry,
      request_attempt_id: request,
    });
    return parsed.success
      ? {
          entry_id: parsed.data.entry_id.toLowerCase(),
          request_attempt_id: parsed.data.request_attempt_id.toLowerCase(),
        }
      : undefined;
  } catch {
    return undefined;
  }
}
